import { render, staticRenderFns } from "./UserQuickView.vue?vue&type=template&id=36f4306e&scoped=true"
import script from "./UserQuickView.vue?vue&type=script&lang=js"
export * from "./UserQuickView.vue?vue&type=script&lang=js"
import style0 from "./UserQuickView.vue?vue&type=style&index=0&id=36f4306e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f4306e",
  null
  
)

export default component.exports